import { useContext, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../components/context/UseContext";

export default function PublicRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, profile } = useContext(UserContext);

  useEffect(() => {
    if (token && token !== "null" && profile) {
      const searchParams = new URLSearchParams(location.search);
      const data = searchParams.get("data");
      const expires = searchParams.get("expires");
      const signature = searchParams.get("signature");
      const storedSlug = localStorage.getItem("world_slug");

      if (data && expires && signature) {
        try {
          localStorage.setItem("arena_hashed_d", encodeURIComponent(data));
          const decoded = atob(decodeURIComponent(encodeURIComponent(data)));
          const decodedArr = decoded.split("|");
          if (decodedArr.length === 3) {
            const [campaignId, gameId, userId] = decodedArr;
            navigate(`/campaign_id/${campaignId}/game_id/${gameId}?userId=${userId}&expires=${expires}&signature=${signature}`);
          } else {
            const [brandId, userId] = decodedArr;
            navigate(`/worlds/${storedSlug}?id=${brandId}&userId=${userId}&expires=${expires}&signature=${signature}`);
          }
        } catch {
          navigate("/home");
        }
      } else {
        navigate("/home");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return <Outlet />;
}
